// @react
import React from 'react'
// @types
import {
  GetConstantsQuery,
  GetConstantsQueryVariables,
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { GET_CONSTANTS } from 'graphql/queries/constants.query'
// @module components
import EducationForm from 'modules/profile/components/Education/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 * 5.0.1.4 Profile - Personal Information - Education
 * UX:https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=866%3A3045
 *
 * fields:
 * User/education	degreeType
 * User/education	programType
 * User/education	schoolName
 * User/education	startDate
 * User/education	endDate
 *
 */

type PropsType = Record<string, unknown>

const Education = (record: PropsType, ref: React.Ref<HTMLDivElement>) => {
  /****************************************
   * GQL HOOKS
   *****************************************/

  const {
    loading: isUserLoading,
    error: isUserError,
    data: userData,
    refetch,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  const {
    loading: isConstantsLoading,
    error: isConstantsError,
    data: constantsData,
  } = useQuery<GetConstantsQuery, GetConstantsQueryVariables>(GET_CONSTANTS, {
    fetchPolicy: 'cache-first',
  })

  /****************************************
   *  RENDER
   ****************************************/

  const isLoading = isUserLoading || isConstantsLoading

  if (
    isUserError ||
    isConstantsError ||
    (!isLoading && (!userData || !constantsData))
  )
    return <QueryError />

  return (
    <div ref={ref}>
      <EducationForm
        data={userData}
        constants={constantsData}
        isLoading={isLoading}
        refetch={refetch}
      />
    </div>
  )
}

export default React.forwardRef<HTMLDivElement>(Education)
